/** A one-line outcome above or below a form: an error to fix, or a confirmation. */
const AuthNotice = ({ tone = 'error', children }) => {
  if (!children) {
    return null;
  }

  return (
    <p className={`auth-notice auth-notice--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      {children}
    </p>
  );
};

export default AuthNotice;
